import { render, staticRenderFns } from "./DashboardChart.vue?vue&type=template&id=9a25787a&scoped=true&"
import script from "./DashboardChart.vue?vue&type=script&lang=js&"
export * from "./DashboardChart.vue?vue&type=script&lang=js&"
import style0 from "./DashboardChart.vue?vue&type=style&index=0&id=9a25787a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a25787a",
  null
  
)

export default component.exports
import {QList,QItem,QItemSection,QTooltip,QItemLabel,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QList,QItem,QItemSection,QTooltip,QItemLabel,QBtn})
